import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ChakraProvider } from "@chakra-ui/react";
import { DataProvider } from "./context/DataContext";
import React from "react";
import theme from "./Theme/Theme";
import Login from "./pages/Login";
import FilmTable from "./pages/FilmTable";
import { useSelector } from "react-redux";
import EditFilmRecord from "./pages/EditFilmRecord";
import "handsontable/dist/handsontable.full.min.css";
import { registerAllModules } from "handsontable/registry";
import EditArchiveRecord from "./pages/ArchiveEdit";
import ArchiveTable from "./pages/ArchiveTable";
import EditVideosRecord from "./pages/VideosEdit";
import VideosTable from "./pages/VideosTable";
import LibrariesTable from "./pages/LibrariesTable";
import EditLibraryRecord from "./pages/LibrariesEdit";
import InsightsTable from "./pages/InsightsTable";
import EditInsightRecord from "./pages/InsightEdit";
import PostsTable from "./pages/PostsTable";
import EditPostRecord from "./pages/PostEdit";
import CalendarEventsTable from "./pages/CalendarEvents/CalendarEventsTable";
import EditCalendarEventsRecord from "./pages/CalendarEvents/CalendarEventsEdit";
import ResearchCategoriesTable from "./pages/ResearchCategoriesTable";
import EditResearchCategory from "./pages/ResearchCategoryEdit";
import SubscribedUsersTable from "./pages/SubscribedUsersTable";
import ProjectsTable from "./pages/ProjectsTable";
import EditProjectRecord from "./pages/ProjectEdit";
import CalendarFocusOfTheDayTable from "./pages/CalendarFocusOfTheDay/CalendarFocusOfTheDayTable";
import EditCalendarFocusOfTheDayRecord from "./pages/CalendarFocusOfTheDay/CalendarFocusOfTheDayEdit";
import DocTypesTable from "./pages/DocumentTypes/DocTypesTable";
import EditDocTypesRecord from "./pages/DocumentTypes/DocTypeEdit";
import VirtualToursTable from "./pages/VirtualTours/VirtualToursTable";
import EditVirtualTourRecord from "./pages/VirtualTours/EditVirtualTourRecord";
import FlipBooksTable from "./pages/FlipBooks/FlipBooksTable";
import EditFlipBookRecord from "./pages/FlipBooks/EditFlipBookRecord";
import CountriesTable from "./pages/Countries/CountriesTable";
import EditCountryRecord from "./pages/Countries/EditCountryRecord";
import PersonalityTable from "./pages/Personality/PersonalityTable";
import PersonalityEdit from "./pages/Personality/PersonalityEdit";
import LocationTable from "./pages/LocationTable";
import EditLocationRecord from "./pages/Location/EditLocationRecord";
import GenresTable from "./pages/Genres/GenresTable";
import EditGenresRecord from "./pages/Genres/EditGenresRecord";
import EventMasterlistTable from "./pages/EventMasterlistTable";
import EditEventMasterlistRecord from "./pages/EventMasterlist/EditEventMasterlistRecord";
import RootLayout from "./components/RootLayout";
import PageNotFound from "./CommonComponents/PageNotFound";
import QuestionsTable from "./pages/QuestionsTable";
import QuestionEdit from "./pages/QuestionEdit";
import DeriveFile from "./pages/DeriveFile";
import LoadDataFile from "./pages/LoadDataFile";
import AuditLog from "./pages/AuditLog";
import EventList from "./pages/EventList";
import EditEventRecord from "./pages/EventList/EditEventRecord";
import FileList from "./pages/FileList";
import "./styles.css";
import DerivedFile from "./pages/Agraphy/DeriveFile";
import ExportListTable from "./pages/Export/ExportListTable";
import ServiceDashboard from "./pages/ServiceDashboard";
import ThemeObjectTable from "./pages/Theme/ThemeObjectTable";
import EditThemeObjectRecord from "./pages/Theme/EditThemeObjectRecord";
import InstitutionTable from "./pages/Institution/InstitutionTable";
import EditInstitutionRecord from "./pages/Institution/EditInstitutionRecord";
import SearchResults from "./pages/SearchPage/SearchResults";
import ExploreEdit from "./pages/ExploreEdit";
import PublicTable from "./pages/Public/PublicTable";
import PublicEdit from "./pages/Public/PublicEdit";

import StaticWordsTable from "./pages/StaticWords/StaticWordsTable";
import EditStaticWordRecord from "./pages/StaticWords/EditStaticWordRecord";
import AdminUsersTable from "./pages/AdminUsers/AdminUsersTable";
import EditAdminUserRecord from "./pages/AdminUsers/EditAdminUserRecord";
// Same production check RootLayout uses for PROD_NAV_ITEMS.
const isProduction =
  process.env.REACT_APP_MONGODB_URL?.includes("https://api.");

function App() {
  registerAllModules();
  const session = useSelector((state) => state.session);
  const isLoggedIn = session?.isAuthenticated;
  const disableContextMenu = (e) => {
    // Allow the native browser context menu (e.g. "Open link in new tab/window")
    // on elements that explicitly opt in, such as Archive grid record links.
    if (e.target?.closest?.("[data-allow-context-menu]")) {
      return;
    }
    e.preventDefault();
  };

  React.useEffect(() => {
    document.addEventListener("contextmenu", disableContextMenu);

    return () => {
      document.removeEventListener("contextmenu", disableContextMenu);
    };
  }, []);

  return (
    <ChakraProvider theme={theme}>
      <DataProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/admin-login" element={<Login />} />
            {/* Routes for the admin panel */}
            <Route path="/" element={<RootLayout />}>
              {isLoggedIn && (
                <>
                  <Route path="/film" element={<FilmTable />} />
                  <Route path="/film/:alias/*" element={<EditFilmRecord />} />
                  {/* ///////// PERSONALITY ROUTES ////////// */}
                  <Route path="/personality" element={<PersonalityTable />} />
                  <Route
                    path="/personality/:alias/*"
                    element={<PersonalityEdit />}
                  />
                  <Route
                    path="/person-actor/:alias/*"
                    element={<PersonalityEdit />}
                  />
                  <Route
                    path="/person-film-maker/:alias/*"
                    element={<PersonalityEdit />}
                  />
                  <Route
                    path="/person-artist/:alias/*"
                    element={<PersonalityEdit />}
                  />
                  <Route
                    path="/person-photographer/:alias/*"
                    element={<PersonalityEdit />}
                  />
                  <Route
                    path="/person-asw/:alias/*"
                    element={<PersonalityEdit />}
                  />
                  <Route
                    path="/person-poly/:alias/*"
                    element={<PersonalityEdit />}
                  />

                  {/* ////////////////////////////////////// */}
                  <Route path="/institution" element={<InstitutionTable />} />
                  <Route
                    path="/institution/:alias/*"
                    element={<EditInstitutionRecord />}
                  />
                  <Route
                    path="/institution-gallery/:alias/*"
                    element={<EditInstitutionRecord />}
                  />
                  <Route
                    path="/institution-publishing-house/:alias/*"
                    element={<EditInstitutionRecord />}
                  />
                  <Route
                    path="/institution-auction-house/:alias/*"
                    element={<EditInstitutionRecord />}
                  />
                  <Route
                    path="/institution-photographic-studio/:alias/*"
                    element={<EditInstitutionRecord />}
                  />

                  {/* ////////////////////////////////////// */}
                  {/* <Route path="/featured" element={<FeaturedTable />} />
                <Route path="/featured/:alias/*" element={<EditFeaturedRecord />} /> */}
                  {/* ////////////////////////////////////// */}
                  <Route path="/location" element={<LocationTable />} />
                  <Route
                    path="/location/:alias/*"
                    element={<EditLocationRecord />}
                  />
                  {/* ////////////  EVENTS ROUTES ////////////// */}
                  <Route path="/event" element={<EventMasterlistTable />} />
                  <Route
                    path="/event/:alias/*"
                    element={<EditEventMasterlistRecord />}
                  />
                  <Route
                    path="/event-exhibition/:alias/*"
                    element={<EditEventMasterlistRecord />}
                  />
                  <Route
                    path="/event-film-festival/:alias/*"
                    element={<EditEventMasterlistRecord />}
                  />
                  {/* ////////////////////////////////////////// */}

                  {/* ////////////  Object Book Journal ROUTES ////////////// */}
                  <Route path="/theme" element={<ThemeObjectTable />} />
                  <Route
                    path="/theme/:alias/*"
                    element={<EditThemeObjectRecord />}
                  />
                  <Route
                    path="/theme-book-ssb/:alias/*"
                    element={<EditThemeObjectRecord />}
                  />
                  <Route
                    path="/theme-book-jou/:alias/*"
                    element={<EditThemeObjectRecord />}
                  />
                  <Route
                    path="/theme-book-mag/:alias/*"
                    element={<EditThemeObjectRecord />}
                  />
                  <Route
                    path="/theme-book-blt/:alias/*"
                    element={<EditThemeObjectRecord />}
                  />
                  <Route
                    path="/theme-categorised-group-of-objects/:alias/*"
                    element={<EditThemeObjectRecord />}
                  />
                  <Route
                    path="/object-book-journal/:alias/*"
                    element={<EditThemeObjectRecord />}
                  />
                  {/* ////////////////////////////////////////// */}
                  {/* ////////////  Archive ROUTES ////////////// */}
                  <Route path="/archive" element={<ArchiveTable />} />
                  <Route
                    path="/archive/:alias/*"
                    element={<EditArchiveRecord />}
                  />
                  <Route
                    path="/archive/create"
                    element={<EditArchiveRecord />}
                  />
                  {/* ////////////  Videos ROUTES ////////////// */}
                  <Route path="/videos" element={<VideosTable />} />
                  <Route
                    path="/videos/:alias/*"
                    element={<EditVideosRecord />}
                  />
                  <Route path="/videos/create" element={<EditVideosRecord />} />
                  <Route path="/libraries" element={<LibrariesTable />} />
                  <Route
                    path="/libraries/create"
                    element={<EditLibraryRecord />}
                  />
                  <Route
                    path="/libraries/:alias/*"
                    element={<EditLibraryRecord />}
                  />
                  <Route path="/insights" element={<InsightsTable />} />
                  <Route
                    path="/insights/create"
                    element={<EditInsightRecord />}
                  />
                  <Route
                    path="/insights/:alias/*"
                    element={<EditInsightRecord />}
                  />
                  <Route path="/posts" element={<PostsTable />} />
                  <Route path="/explore" element={<ExploreEdit />} />
                  <Route path="/posts/create" element={<EditPostRecord />} />
                  <Route path="/posts/:alias/*" element={<EditPostRecord />} />
                  <Route
                    path="/posts/:alias/quiz"
                    element={<QuestionsTable />}
                  />
                  <Route
                    path="/posts/:alias/quiz/:questionId"
                    element={<QuestionEdit />}
                  />
                  <Route path="/projects" element={<ProjectsTable />} />
                  <Route
                    path="/projects/:alias/*"
                    element={<EditProjectRecord />}
                  />
                  <Route
                    path="/projects/create"
                    element={<EditProjectRecord />}
                  />
                  <Route path="/flip-books" element={<FlipBooksTable />} />
                  <Route
                    path="/flip-books/:alias/*"
                    element={<EditFlipBookRecord />}
                  />
                  <Route
                    path="/flip-books/create"
                    element={<EditFlipBookRecord />}
                  />
                  <Route
                    path="/calendar/events"
                    element={<CalendarEventsTable />}
                  />
                  <Route
                    path="/calendar/events/:alias/*"
                    element={<EditCalendarEventsRecord />}
                  />
                  <Route
                    path="/calendar/events/create"
                    element={<EditCalendarEventsRecord />}
                  />
                  <Route
                    path="/calendar/focus-of-the-day"
                    element={<CalendarFocusOfTheDayTable />}
                  />
                  <Route
                    path="/calendar/focus-of-the-day/:alias/*"
                    element={<EditCalendarFocusOfTheDayRecord />}
                  />
                  <Route
                    path="/calendar/focus-of-the-day/create"
                    element={<EditCalendarFocusOfTheDayRecord />}
                  />
                  <Route path="/document-types" element={<DocTypesTable />} />
                  <Route
                    path="/document-types/:alias/*"
                    element={<EditDocTypesRecord />}
                  />
                  <Route
                    path="/document-types/create"
                    element={<EditDocTypesRecord />}
                  />
                  <Route path="/countries" element={<CountriesTable />} />
                  <Route
                    path="/countries/:alias/*"
                    element={<EditCountryRecord />}
                  />
                  <Route
                    path="/countries/create"
                    element={<EditCountryRecord />}
                  />
                  <Route
                    path="/virtual-tours"
                    element={<VirtualToursTable />}
                  />
                  <Route
                    path="/virtual-tours/:alias/*"
                    element={<EditVirtualTourRecord />}
                  />
                  <Route
                    path="/virtual-tours/create"
                    element={<EditVirtualTourRecord />}
                  />
                  <Route path="/genres" element={<GenresTable />} />
                  <Route
                    path="/genres/:alias/*"
                    element={<EditGenresRecord />}
                  />
                  <Route path="/genres/create" element={<EditGenresRecord />} />
                  <Route
                    path="/research-categories"
                    element={<ResearchCategoriesTable />}
                  />
                  <Route
                    path="/research-categories/:alias/*"
                    element={<EditResearchCategory />}
                  />
                  <Route
                    path="/research-categories/:alias/research-centre/archive/:archiveAlias/*"
                    element={<EditArchiveRecord />}
                  />
                  <Route
                    path="/research-categories/:alias/research-centre/videos/:videoAlias/*"
                    element={<EditVideosRecord />}
                  />
                  <Route
                    path="/research-categories/:alias/research-centre/library/:libraryAlias/*"
                    element={<EditLibraryRecord />}
                  />
                  <Route
                    path="/subscribed-users"
                    element={<SubscribedUsersTable />}
                  />
                  <Route path="/admin-users" element={<AdminUsersTable />} />
                  <Route
                    path="/admin-users/create"
                    element={<EditAdminUserRecord />}
                  />
                  <Route
                    path="/admin-users/:id/*"
                    element={<EditAdminUserRecord />}
                  />
                  <Route path="/static-words" element={<StaticWordsTable />} />
                  <Route
                    path="/static-words/:id/*"
                    element={<EditStaticWordRecord />}
                  />
                  <Route
                    path="/static-words/create"
                    element={<EditStaticWordRecord />}
                  />
                  {/* File derivation runs on staging only; production has no derivation queue. */}
                  {!isProduction && (
                    <Route path="/derive-file" element={<DeriveFile />} />
                  )}
                  <Route path="/load-data" element={<LoadDataFile />} />
                  <Route path="/audit-log" element={<AuditLog />} />
                  <Route path="/events" element={<EventList />} />
                  <Route
                    path="/events/:alias/*"
                    element={<EditEventRecord />}
                  />
                  <Route path="/events/create" element={<EditEventRecord />} />
                  <Route path="/file-list" element={<FileList />} />
                  <Route path="/agraphy/load-file" element={<DerivedFile />} />
                  <Route path="/export" element={<ExportListTable />} />
                  <Route
                    path="/service-dashboard"
                    element={<ServiceDashboard />}
                  />
                  <Route
                    path="/search/research-centre/:tabValue"
                    element={<SearchResults />}
                  />
                  {/* ////////////  PUBLIC PAGES ROUTES ////////////// */}
                  <Route path="/public" element={<PublicTable />} />
                  <Route path="/public/create" element={<PublicEdit />} />
                  <Route path="/public/:slug/*" element={<PublicEdit />} />
                  {/* ////////////////////////////////////////// */}
                </>
              )}
              <Route path="*" element={<PageNotFound />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </DataProvider>
    </ChakraProvider>
  );
}

export default App;
